// extracted by extract-css-chunks-webpack-plugin
module.exports = {"swiper":"swiper_2B4Sb","cover":"cover_1mz5O","cover_next":"cover_next_1fkoH","cover_prev":"cover_prev_f3Ni9"};